import React from 'react';
import { Clapperboard } from 'lucide-react';
import { DEMO_LIBRARY_VIDEO_THUMB } from './demoStockImages';

/** Platform draft card with thumbnail — matches app DraftCard thumb strip (no actions). */
export function DraftAssetCard({
  title,
  platformName = 'Instagram',
  platformColor = '#9333ea',
  logoPath = '/platform-logos/instagram-logo.png',
  fallbackIcon,
  thumbnailUrl = DEMO_LIBRARY_VIDEO_THUMB,
  thumbnailLoading,
  className = '',
}) {
  return (
    <div className={`mkt-draft-asset-card${className ? ` ${className}` : ''}`}>
      <div className="mkt-draft-asset-card-thumb-wrap">
        {thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt=""
            className="mkt-draft-asset-card-thumb-img"
            loading={thumbnailLoading || 'eager'}
            decoding="async"
          />
        ) : (
          <div className="mkt-draft-asset-card-thumb-fallback" aria-hidden />
        )}
      </div>
      <div className="mkt-draft-asset-card-meta">
        <span className="mkt-draft-asset-card-platform" style={{ background: platformColor }}>
          {logoPath ? (
            <img src={logoPath} alt="" className="mkt-draft-asset-card-platform-logo" />
          ) : fallbackIcon ? (
            <span className="mkt-draft-asset-card-platform-emoji" aria-hidden>
              {fallbackIcon}
            </span>
          ) : (
            <Clapperboard className="ui-icon-xs" color="#fff" aria-hidden />
          )}
        </span>
        <div className="mkt-draft-asset-card-copy">
          <span className="mkt-draft-asset-card-platform-name">{platformName}</span>
          <span className="mkt-draft-asset-card-label">Draft</span>
        </div>
      </div>
      {title ? <p className="mkt-draft-asset-card-title">{title}</p> : null}
    </div>
  );
}
